import { Component, inject, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../../core/auth/auth.service';
import { TranslationService } from '../../../core/i18n/translation.service';

@Component({
  selector: 'app-change-password-page',
  imports: [ReactiveFormsModule],
  templateUrl: './change-password-page.component.html',
  styleUrl: './login-page.component.css',
})
export class ChangePasswordPageComponent {
  private readonly fb = inject(FormBuilder);
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  protected readonly i18n = inject(TranslationService);
  protected readonly submitting = signal(false);
  protected readonly error = signal('');
  protected readonly form = this.fb.nonNullable.group({
    password: ['', [Validators.required, Validators.minLength(7)]],
    confirmation: ['', [Validators.required]],
  });

  protected submit(): void {
    const { password, confirmation } = this.form.getRawValue();
    if (this.form.invalid || password !== confirmation || this.submitting()) {
      this.form.markAllAsTouched();
      this.error.set(this.i18n.t(password !== confirmation ? 'auth.changePassword.errors.mismatch' : 'auth.changePassword.errors.invalid'));
      return;
    }
    this.submitting.set(true);
    this.error.set('');
    void this.auth.changePassword(password).then(() => {
      void this.router.navigate(['/login'], { queryParams: { passwordChanged: '1' } });
    }).catch(() => {
      this.submitting.set(false);
      this.error.set(this.i18n.t('auth.changePassword.errors.failed'));
    });
  }
}
